import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-tabla-view-clientes',
  templateUrl: './tabla-view-clientes.component.html',
  styleUrls: ['./tabla-view-clientes.component.scss']
})
export class TablaViewClientesComponent implements OnInit {
  @Input() listaClientes: any[];

  headElements: string[];

  constructor() {
  }

  ngOnInit() {
  }
  
  ngOnChangengOnChanges(changes: SimpleChanges): void {
    console.log('SE CARGO LA LISTA DE CLIENTES');
    if (changes || changes.listaClientes) {
      this.headElements = ['Fila', 'RUT', 'Cliente', 'Errores'];
      this.listaClientes = changes.listaClientes.currentValue;
    }
  }

}
